// src/components/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { loginUser, logoutUser } from '../api/apiService';

// Default + named export para facilitar imports
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Opcional: aquí podrías llamar a un endpoint check_session.php
    // para restaurar sesión si hay cookie de PHP.
  }, []);

  const login = async (email, password) => {
    const { user: u } = await loginUser(email, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    await logoutUser();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook para usar contexto
export const useAuth = () => useContext(AuthContext);

// También exportas AuthContext por defecto
export default AuthContext;
